import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Progress } from "@/components/ui/progress";
import { 
  ArrowRight, ArrowLeft, CheckCircle, XCircle, 
  RotateCcw, Home, Trophy, AlertCircle
} from "lucide-react";

// COMPASS Questions with correct answers
const COMPASS_QUESTIONS = [
  {
    id: 1,
    situation: "Due persone amiche stabiliscono un programma per trascorrere le vacanze insieme. Pochi giorni prima di partire, una telefona all'altra per dirle che ha deciso di cambiare il programma. L'altra risponde: \"Oh, mi prendi proprio alla sprovvista. Vorrei pensarci un momento sopra per rendermi meglio conto di come stanno ora le cose\".",
    correct: "AS"
  },
  {
    id: 2,
    situation: "Un genitore rimprovera i figli che non hanno messo in ordine la loro camera. Dice: \"Siete i peggiori ragazzacci del mondo! Se lo avessi saputo, non avrei mai fatto figli!\".",
    correct: "AG"
  },
  {
    id: 3,
    situation: "Un marito vuole guardare la partita alla televisione. La moglie vorrebbe guardare un altro programma. Lei dice: \"Beh, non importa, tesoro, guardati pure la partita. Io forse mi metto a stirare\".",
    correct: "AN"
  },
  {
    id: 4,
    situation: "Il capoufficio ha rimproverato un dipendente sul lavoro. Il dipendente risponde: \"Mi pare che alcune sue critiche siano giuste, ma avrei preferito che nel farmele lei fosse stato meno offensivo\".",
    correct: "AS"
  },
  {
    id: 5,
    situation: "Una persona finisce un lavoretto artigianale che gli è venuto particolarmente bene e di cui si sente orgogliosa. La sera incontra un amico che gli domanda come è andata la sua giornata. Lui risponde: \"Sono molto contento perché oggi sono riuscito a finire bene una cosa a cui stavo lavorando. Mi piacerebbe fartela vedere\".",
    correct: "AS"
  },
  {
    id: 6,
    situation: "Un bambino di dieci anni ha interrotto tre volte, per motivi non urgenti, la telefonata che sta facendo il genitore. Il genitore gli ha già chiesto assertivamente di non insistere. Il bambino lo disturba di nuovo. Il genitore dice: \"Non mi riesce di fare due cose insieme: telefonare e darti retta. Quindi prima finisco questa telefonata, e poi parliamo io e te\".",
    correct: "AS"
  },
  {
    id: 7,
    situation: "In una riunione c'è una sola donna e tanti uomini. Viene chiesto a lei di fare la segretaria della riunione. Lei risponde: \"Io sono disposta a fare la mia parte di lavoro, e questa volta gli appunti li prendo io. Ma per le prossime riunioni faremo a turno\".",
    correct: "AS"
  },
  {
    id: 8,
    situation: "Una persona chiede a un conoscente di prestargli l'automobile. Questo risponde: \"Ma è matto? Io non presto l'automobile a nessuno!\".",
    correct: "AG"
  },
  {
    id: 9,
    situation: "Al piano superiore, il giradischi suona a tutto volume. L'inquilino del piano di sotto telefona e dice: \"Pronto. Io abito al piano di sotto. Il giradischi è molto rumoroso e mi disturba. Per favore, volete abbassarlo?\".",
    correct: "AS"
  },
  {
    id: 10,
    situation: "Una donna telefona a un'amica per dirle che ha bisogno disperato del suo aiuto per organizzare una colletta a scopo di beneficenza. L'amica non vorrebbe saperne, e le risponde: \"Oh, che peccato, Francesca, ma Giuseppe se la prenderebbe troppo con me se io accettassi. Lui dice che io mi metto sempre in troppi impicci. Lo sai come la pensa su certe cose...\".",
    correct: "AN"
  },
  {
    id: 11,
    situation: "L'autobus è affollato di studenti delle medie che parlano animatamente tra di loro. Una persona vorrebbe scendere, ma nessuno le dà retta quando chiede \"permesso\". Infine, questa persona dice: \"Ma insomma, ragazzi, che vi prende?! Io devo scendere alla prossima fermata!\".",
    correct: "AG"
  },
  {
    id: 12,
    situation: "Una persona riceve un complimento da un'altra persona amica a proposito del suo aspetto. La prima risponde: \"Grazie, mi fa molto piacere. Anch'io oggi mi piaccio di più\".",
    correct: "AS"
  },
  {
    id: 13,
    situation: "Uno studente arriva a scuola in ritardo per la terza volta. L'insegnante gli dice: \"Se non sei presente quando io comincio la lezione, poi devo ripeterne un pezzo e questo fa perdere tempo. Io comincio a seccarmi dei tuoi ritardi\".",
    correct: "AS"
  },
  {
    id: 14,
    situation: "Fila alla cassa del supermercato. Una persona con un solo acquisto chiede alla persona che gli sta davanti di lasciarla passare per prima. Questa risponde: \"Capisco che lei non voglia fare la fila, ma ci sono prima io e anch'io vorrei sbrigarmi\".",
    correct: "AS"
  },
  {
    id: 15,
    situation: "Un genitore parla al telefono con un figlio sposato e gli chiede di venire a trovarlo. Quando il figlio gentilmente rifiuta, il genitore dice: \"Tu non sei mai disponibile quando io ho bisogno di te. Pensi sempre soltanto a te stesso\".",
    correct: "AG"
  },
  {
    id: 16,
    situation: "Il marito esige che la cena sia in tavola quando torna a casa dal lavoro, e si arrabbia se non è pronta. La moglie: \"Oh, come mi dispiace per la cena. Lo so che sei stanco e affamato... È tutta colpa mia. Sono proprio una disgraziata\".",
    correct: "AN"
  },
  {
    id: 17,
    situation: "Una persona ha deciso di dedicare un'oretta, dalle 4 alle 5 del pomeriggio, alle cose che desidera o ha bisogno di fare. Un'altra persona gli chiede di vederla proprio a quell'ora. La prima risponde: \"Beh, sì, ci possiamo vedere. Allora sarebbe lunedì alle quattro. Ma è sicuro che va bene per lei?\".",
    correct: "AN"
  },
  {
    id: 18,
    situation: "Dopo un breve contrasto di opinioni, il partner ammutolisce. La partner dice: \"Eccolo, ora mette il muso. Una volta tanto, ti farebbe male sputare il rospo?\".",
    correct: "AG"
  },
  {
    id: 19,
    situation: "Il marito ha criticato l'aspetto della moglie davanti agli amici. La moglie gli dice: \"Io mi sento offesa quando mi critichi davanti agli altri. Se hai qualcosa da dire, per piacere dimmelo prima che usciamo di casa\".",
    correct: "AS"
  },
  {
    id: 20,
    situation: "Una persona prende spesso piccole somme in prestito dagli amici e non le restituisce se non le vengono chieste. Ora chiede un altro piccolo prestito a qualcuno che preferirebbe non farglielo e che gli risponde: \"Oggi sono uscito con appena appena i soldi per il pranzo\".",
    correct: "AN"
  },
  {
    id: 21,
    situation: "Una donna chiede continuamente in prestito l'aspirapolvere a una vicina. L'ultima volta lo ha rotto. Quando lo chiede di nuovo in prestito, la vicina le risponde: \"Mi dispiace, ma non voglio più prestare il mio aspirapolvere. L'ultima volta che l'ho fatto, mi è tornato rotto\".",
    correct: "AS"
  },
  {
    id: 22,
    situation: "Una ragazza si sottopone a un colloquio per un posto di lavoro. Durante l'incontro, il selezionatore la guarda maliziosamente e le dice: \"A guardarla, lei sembra avere proprio tutti i requisiti a posto\". Lei risponde: \"Sono sicura di essere in grado di fare il mio lavoro\".",
    correct: "AS"
  },
  {
    id: 23,
    situation: "Un impiegato sta andando verso la macchina delle fotocopie, e un altro impiegato, che ha l'abitudine di chiedergli di fare delle fotocopie anche per lui, gli domanda dove sta andando. Il primo risponde: \"Vado al ballo in maschera... Non lo vedi dove sto andando?\".",
    correct: "AG"
  },
  {
    id: 24,
    situation: "Una madre chiede per la seconda volta in una settimana a un'amica senza figli di fare da baby sitter a suo figlio mentre lei sbriga delle commissioni. L'amica risponde: \"Tu ti vuoi approfittare di me, ma io non ci sto mica! Ai tuoi figli ci devi badare tu!\".",
    correct: "AG"
  },
  {
    id: 25,
    situation: "Un impiegato vorrebbe un aumento e dice al principale: \"Ecco... lei crede che... insomma... sarebbe possibile... parlare del mio stipendio?\".",
    correct: "AN"
  },
  {
    id: 26,
    situation: "Una persona chiede un passaggio in auto a un amico che ha fretta e che non vuole andare troppo fuori strada. Quindi risponde: \"Oggi ho fretta e ti posso portare a una stazione di taxi o a una fermata dell'autobus, ma non ce la faccio a portarti fino a casa\".",
    correct: "AS"
  },
  {
    id: 27,
    situation: "A uno studente è piaciuta la lezione fatta dall'insegnante, e dice: \"Lei rende interessante questa materia. Mi piace il modo in cui insegna\".",
    correct: "AS"
  },
  {
    id: 28,
    situation: "Una persona sta parlando al telefono con un'altra persona amica, ma vorrebbe concludere la conversazione. Allora dice: \"Scusami, ma devo scappare perché in cucina mi si sta bruciando il pranzo. Mi dispiace tanto, ma spero che tu mi capisca\".",
    correct: "AN"
  },
  {
    id: 29,
    situation: "Gli impiegati di un ufficio stanno discutendo come organizzare e dividersi un lavoro che devono svolgere insieme. Uno degli impiegati avanza una proposta e poi chiede agli altri il loro parere. Alcuni sono d'accordo e altri fanno delle critiche. Quando arriva il suo turno, un impiegato che non ha capito bene la proposta del primo, dice: \"Mi sembra una proposta molto interessante, e sono completamente d'accordo\".",
    correct: "AN"
  },
  {
    id: 30,
    situation: "Una ragazza sta per uscire con delle amiche. La madre le consiglia di prendere un golf più pesante perché potrebbe sentire freddo. La ragazza risponde: \"Tu ti devi sempre impicciare degli affari miei. Quando lo capirai che non sono più una bambina e che lo so io come vestirmi?\".",
    correct: "AG"
  }
];

const ANSWER_OPTIONS = [
  { value: "AS", label: "Assertivo", description: "Esprime i propri bisogni rispettando gli altri", color: "bg-green-100 border-green-500 text-green-700" },
  { value: "AN", label: "Anassertivo", description: "Non esprime i propri bisogni, si sottomette", color: "bg-yellow-100 border-yellow-500 text-yellow-700" },
  { value: "AG", label: "Aggressivo", description: "Esprime i propri bisogni senza rispettare gli altri", color: "bg-red-100 border-red-500 text-red-700" }
];

const NOTA_METODOLOGICA = `Il questionario COMPASS viene utilizzato per addestrarsi a discriminare fra le varie modalità di reazione a situazioni sociali specifiche.

Consta di 30 casi, ognuno dei quali descrive una situazione sociale specifica e la reazione di una persona alla situazione in cui si trova.

Per ogni caso, decidi se la reazione ti sembra di tipo:
• ASSERTIVO (AS) - Esprime i propri bisogni rispettando gli altri
• ANASSERTIVO (AN) - Non esprime i propri bisogni, si sottomette
• AGGRESSIVO (AG) - Esprime i propri bisogni senza rispettare gli altri

Riceverai un feedback immediato dopo ogni risposta.

Fonte: Lange & Jakubowski (1976), adattamento Crone & Schimmelpfennig (1980).`;

const CompassTest = ({ onBack }) => {
  const [step, setStep] = useState("intro"); // intro, test, results
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState({});
  const [showFeedback, setShowFeedback] = useState(false);
  const [lastAnswer, setLastAnswer] = useState(null);

  const handleAnswer = (answer) => {
    const question = COMPASS_QUESTIONS[currentQuestion];
    const isCorrect = answer === question.correct;
    
    setAnswers(prev => ({
      ...prev,
      [question.id]: { answer, isCorrect, correct: question.correct }
    }));
    
    setLastAnswer({ answer, isCorrect, correct: question.correct });
    setShowFeedback(true);
  };

  const nextQuestion = () => {
    setShowFeedback(false);
    setLastAnswer(null);
    
    if (currentQuestion < COMPASS_QUESTIONS.length - 1) {
      setCurrentQuestion(prev => prev + 1);
    } else {
      setStep("results");
    }
  };

  const calculateResults = () => {
    const total = Object.keys(answers).length;
    const correct = Object.values(answers).filter(a => a.isCorrect).length;
    const wrong = Object.values(answers).filter(a => !a.isCorrect);
    const percentage = Math.round((correct / total) * 100);
    
    return { total, correct, wrong, percentage };
  };

  const resetTest = () => {
    setStep("intro");
    setCurrentQuestion(0);
    setAnswers({});
    setShowFeedback(false);
    setLastAnswer(null);
  };

  const getAnswerLabel = (value) => {
    return ANSWER_OPTIONS.find(o => o.value === value)?.label || value;
  };

  // ============ INTRO ============
  if (step === "intro") {
    return (
      <div className="space-y-6">
        <div className="flex items-center gap-3">
          <Button variant="ghost" size="sm" onClick={onBack} className="rounded-full">
            <ArrowLeft className="w-4 h-4 mr-1" /> Indietro
          </Button>
        </div>
        
        <div className="text-center space-y-4">
          <div className="w-20 h-20 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-full flex items-center justify-center mx-auto">
            <span className="text-4xl">🧭</span>
          </div>
          <h1 className="text-2xl font-bold text-gray-800">Test COMPASS</h1>
          <p className="text-gray-600">Riconosci i comportamenti assertivi, anassertivi e aggressivi</p>
        </div>

        <Card>
          <CardContent className="p-6">
            <pre className="whitespace-pre-wrap text-sm text-gray-700 font-sans leading-relaxed">
              {NOTA_METODOLOGICA}
            </pre>
          </CardContent>
        </Card>

        <div className="grid grid-cols-3 gap-3">
          {ANSWER_OPTIONS.map(opt => (
            <div key={opt.value} className={`p-3 rounded-xl border-2 ${opt.color} text-center`}>
              <p className="font-bold">{opt.value}</p>
              <p className="text-xs">{opt.label}</p>
            </div>
          ))}
        </div>

        <Button 
          onClick={() => setStep("test")} 
          className="w-full rounded-xl bg-gradient-to-r from-teal-600 to-cyan-600 hover:from-teal-700 hover:to-cyan-700"
          size="lg"
        >
          Inizia il Test <ArrowRight className="w-5 h-5 ml-2" />
        </Button>
      </div>
    );
  }

  // ============ TEST ============
  if (step === "test") {
    const question = COMPASS_QUESTIONS[currentQuestion];
    const progress = ((currentQuestion + 1) / COMPASS_QUESTIONS.length) * 100;

    return (
      <div className="space-y-6">
        {/* Progress */}
        <div className="space-y-2">
          <div className="flex justify-between text-sm text-gray-600">
            <span>Domanda {currentQuestion + 1} di {COMPASS_QUESTIONS.length}</span>
            <span>{Math.round(progress)}%</span>
          </div>
          <Progress value={progress} className="h-2" />
        </div>

        {/* Question */}
        <Card>
          <CardContent className="p-6">
            <p className="text-gray-800 leading-relaxed">{question.situation}</p>
          </CardContent>
        </Card>

        {/* Answer Options */}
        {!showFeedback ? (
          <div className="space-y-3">
            <p className="text-sm font-medium text-gray-700 text-center">Questa reazione è:</p>
            {ANSWER_OPTIONS.map(opt => (
              <button
                key={opt.value}
                onClick={() => handleAnswer(opt.value)}
                className={`w-full p-4 rounded-xl border-2 text-left transition-all hover:shadow-md ${
                  opt.value === "AS" ? "border-green-300 hover:border-green-500 hover:bg-green-50" :
                  opt.value === "AN" ? "border-yellow-300 hover:border-yellow-500 hover:bg-yellow-50" :
                  "border-red-300 hover:border-red-500 hover:bg-red-50"
                }`}
              >
                <div className="flex items-center gap-3">
                  <span className="text-2xl font-bold opacity-50">{opt.value}</span>
                  <div>
                    <p className="font-semibold">{opt.label}</p>
                    <p className="text-xs text-gray-500">{opt.description}</p>
                  </div>
                </div>
              </button>
            ))}
          </div>
        ) : (
          /* Feedback */
          <div className="space-y-4">
            <Card className={`border-2 ${lastAnswer.isCorrect ? 'border-green-500 bg-green-50' : 'border-red-500 bg-red-50'}`}>
              <CardContent className="p-6">
                <div className="flex items-center gap-3 mb-3">
                  {lastAnswer.isCorrect ? (
                    <CheckCircle className="w-8 h-8 text-green-500" />
                  ) : (
                    <XCircle className="w-8 h-8 text-red-500" />
                  )}
                  <div>
                    <p className={`font-bold text-lg ${lastAnswer.isCorrect ? 'text-green-700' : 'text-red-700'}`}>
                      {lastAnswer.isCorrect ? "Corretto!" : "Sbagliato"}
                    </p>
                    {!lastAnswer.isCorrect && (
                      <p className="text-sm text-gray-600">
                        La tua risposta: <strong>{getAnswerLabel(lastAnswer.answer)}</strong>
                      </p>
                    )}
                  </div>
                </div>
                
                <div className={`p-3 rounded-lg ${
                  lastAnswer.correct === "AS" ? "bg-green-100" :
                  lastAnswer.correct === "AN" ? "bg-yellow-100" : "bg-red-100"
                }`}>
                  <p className="text-sm">
                    <strong>Risposta corretta:</strong> {getAnswerLabel(lastAnswer.correct)} ({lastAnswer.correct})
                  </p>
                </div>
              </CardContent>
            </Card>

            <Button 
              onClick={nextQuestion} 
              className="w-full rounded-xl"
              size="lg"
            >
              {currentQuestion < COMPASS_QUESTIONS.length - 1 ? (
                <>Prossima domanda <ArrowRight className="w-4 h-4 ml-2" /></>
              ) : (
                <>Vedi risultati <Trophy className="w-4 h-4 ml-2" /></>
              )}
            </Button>
          </div>
        )}
      </div>
    );
  }

  // ============ RESULTS ============
  if (step === "results") {
    const results = calculateResults();
    
    let feedback = "";
    let feedbackColor = "";
    
    if (results.percentage >= 80) {
      feedback = "Eccellente! Hai un'ottima capacità di riconoscere i diversi stili comunicativi.";
      feedbackColor = "text-green-700 bg-green-50 border-green-200";
    } else if (results.percentage >= 60) {
      feedback = "Buon risultato! Hai una discreta capacità di distinguere gli stili, ma c'è margine di miglioramento.";
      feedbackColor = "text-yellow-700 bg-yellow-50 border-yellow-200";
    } else {
      feedback = "C'è spazio per migliorare. Rivedi le situazioni sbagliate per capire meglio le differenze.";
      feedbackColor = "text-red-700 bg-red-50 border-red-200";
    }

    return (
      <div className="space-y-6">
        <div className="text-center space-y-4">
          <div className="w-20 h-20 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-full flex items-center justify-center mx-auto">
            <Trophy className="w-10 h-10 text-white" />
          </div>
          <h1 className="text-2xl font-bold text-gray-800">Risultati Test COMPASS</h1>
        </div>

        {/* Score Card */}
        <Card className="border-2 border-indigo-200 bg-gradient-to-br from-indigo-50 to-purple-50">
          <CardContent className="p-6 text-center">
            <p className="text-6xl font-bold text-indigo-600 mb-2">{results.correct}/{results.total}</p>
            <p className="text-xl text-gray-600">Risposte corrette</p>
            <div className="mt-4">
              <Progress value={results.percentage} className="h-3" />
              <p className="text-sm text-gray-500 mt-1">{results.percentage}%</p>
            </div>
          </CardContent>
        </Card>

        {/* Feedback */}
        <Card className={`border ${feedbackColor}`}>
          <CardContent className="p-4">
            <p className="text-sm">{feedback}</p>
          </CardContent>
        </Card>

        {/* Wrong Answers */}
        {results.wrong.length > 0 && (
          <div className="space-y-3">
            <h3 className="font-semibold text-gray-700 flex items-center gap-2">
              <AlertCircle className="w-5 h-5 text-red-500" />
              Domande sbagliate ({results.wrong.length})
            </h3>
            
            <div className="space-y-3 max-h-80 overflow-y-auto">
              {results.wrong.map((item, idx) => {
                const questionData = COMPASS_QUESTIONS.find(q => answers[q.id] === item);
                const questionId = Object.keys(answers).find(key => answers[key] === item);
                const question = COMPASS_QUESTIONS.find(q => q.id === parseInt(questionId));
                
                return (
                  <Card key={`wrong-${question?.id || idx}`} className="border-red-200 bg-red-50/50">
                    <CardContent className="p-4">
                      <div className="flex items-start gap-2 mb-2">
                        <Badge variant="outline" className="text-xs">#{question?.id}</Badge>
                      </div>
                      <p className="text-sm text-gray-700 mb-2 line-clamp-3">{question?.situation}</p>
                      <div className="flex gap-2 text-xs">
                        <span className="text-red-600">Tua risposta: <strong>{getAnswerLabel(item.answer)}</strong></span>
                        <span className="text-green-600">Corretta: <strong>{getAnswerLabel(item.correct)}</strong></span>
                      </div>
                    </CardContent>
                  </Card>
                );
              })}
            </div>
          </div>
        )}

        {/* Actions */}
        <div className="flex gap-3">
          <Button variant="outline" onClick={resetTest} className="flex-1 rounded-xl">
            <RotateCcw className="w-4 h-4 mr-2" /> Rifai il test
          </Button>
          <Button onClick={onBack} className="flex-1 rounded-xl bg-gradient-to-r from-teal-600 to-cyan-600">
            <Home className="w-4 h-4 mr-2" /> Torna ai test
          </Button>
        </div>
      </div>
    );
  }

  return null;
};

export default CompassTest;
